import { useState } from 'react';
import Scrollspy from 'common/components/Scrollspy';
import { IconMenu2, IconX } from '@tabler/icons-react';
import ScrollSpyMenu from 'common/components/ScrollSpyMenu';
import Logo from 'common/components/UIElements/Logo';
import Button from 'common/components/Button';
import Container from 'common/components/UI/Container';
import NextImage from 'common/components/NextImage';
import NavbarWrapper, { MenuArea, MobileMenu } from './navbar.style';
import { navbar } from 'common/data/AppCreative';

interface NavbarState {
  mobileMenu: boolean;
}

interface NavMenuItem {
  id: number;
  label: string;
  path: string;
  staticLink?: string;
  isCta?: boolean;
  icon?: string;
}

interface RenderLinkProps {
  menu: NavMenuItem;
}

const RenderLinkWithIcon = ({ menu }: RenderLinkProps) => (
  <div className="icon-login">
    {menu.icon ? (
      <NextImage className="icon" src={menu.icon} alt={menu.label} />
    ) : (
      ''
    )}
    <a className={menu.icon ? 'icon-label' : 'no-icon-label'} href={menu.path}>
      {menu.label}
    </a>
  </div>
);

const Navbar = () => {
  const { logoImage, navMenu } = navbar;
  const [state, setState] = useState<NavbarState>({ mobileMenu: false });

  const toggleHandler = (type: 'menu') => {
    if (type === 'menu') {
      setState((s) => ({ ...s, mobileMenu: !s.mobileMenu }));
    }
  };

  const scrollItems: string[] = navMenu.map((item) => item.path.slice(1));

  return (
    <NavbarWrapper className="navbar">
      <Container>
        <Logo
          href="/"
          logoSrc={logoImage}
          title="App Creative"
          className="main-logo"
        />

        <MenuArea>
          <ScrollSpyMenu
            className="menu"
            menuItems={navMenu.filter((m) => !m.isCta)}
          />

          {navMenu
            .filter((m) => m.isCta)
            .map((cta) => (
              <Button
                key={cta.id}
                className="trail"
                title={cta.label}
                onClick={() => {
                  window.location.href = cta.path;
                }}
                style={{
                  backgroundColor: '#156b83',
                  color: '#fff',
                  marginLeft: '20px',
                  marginRight: '10px',
                }}
              />
            ))}

          <Button
            className="menubar"
            icon={
              state.mobileMenu ? (
                <IconX className="bar" />
              ) : (
                <IconMenu2 className="close" />
              )
            }
            variant="textButton"
            onClick={() => toggleHandler('menu')}
          />
        </MenuArea>
      </Container>

      <MobileMenu
        className={`mobile-menu ${state.mobileMenu ? 'active' : ''}`}
      >
        <Container>
          <Scrollspy
            className="menu"
            items={scrollItems}
            currentClassName="active"
          >
            {navMenu.map((m, index) => (
              <li key={`menu_key${index}`}>
                <RenderLinkWithIcon menu={m} />
              </li>
            ))}
          </Scrollspy>
        </Container>
      </MobileMenu>
    </NavbarWrapper>
  );
};

export default Navbar;
